module.exports = __webpack_public_path__ + "static/media/floor_se.f665a1d3.png";